<template>
  <v-progress-linear
    v-if="call === null"
    indeterminate
    color="green"
  />

  <div class="row pa-3" v-else>
    <input type="text" class="urlInput" :value="callUrl">
    <!-- Информация о вызове -->
    <div class="col-md-6 col-lg-4">
      <v-card class="mt-4">
        <v-card-title>Информация о вызове

          <v-spacer />

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn v-on="on" icon :href="`http://statix.oline/calls/${uid}`" target="_blank">
                <v-icon>mdi-dock-window</v-icon>
              </v-btn>
            </template>
            <span>Перейти в звонок в StatiX</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn v-on="on" icon :href="callUrl" target="_blank">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </template>
            <span>Перейти в звонок в StatiZ</span>
          </v-tooltip>

        </v-card-title>

        <!-- Общие/Мета/История вызовов -->
        <v-tabs show-arrows>
          <v-tab @click="callInfoType = 'default'">Общие</v-tab>
          <v-tab
            v-if="call.meta !== undefined && call.meta !== null"
            @click="callInfoType = 'meta'"
          >Meta</v-tab>

          <v-tab v-if="call.viewers"
            @click="callInfoType = 'browsing_history'"
          >Просмотры</v-tab>
          <v-tab @click="callInfoType = 'history'">История вызова</v-tab>
        </v-tabs>

        <v-card-text class="pt-0 ">
          <div class="subheading black--text">
            <v-simple-table dense v-if="callInfoType === 'default'">
              <template #default>
                <tbody>
                <tr>
                  <td><b>Статус</b></td>
                  <td>
                    <v-chip
                      v-if="call.status_name"
                      text-color="white"
                      small
                      :color="callStatus"
                      v-text="call.status_name" title="Скопировать ссылку"
                    />
                  </td>
                </tr>
                <tr>
                  <td><b>Uid Вызова</b></td>
                  <td @click="copyUrl">
                    <v-chip text-color="white" small color="success" v-text="call.uid" class="copyUrl-chip" />
                  </td>
                </tr>
                <tr>
                  <td><b>Номер звонящего</b></td>
                  <td v-text="call.phone"></td>
                </tr>
                <tr>
                  <td><b>Очередь</b></td>
                  <td v-text="call.queue"></td>
                </tr>
                <tr>
                  <td><b>Время поступления в очередь</b></td>
                  <td v-text="formatDate(call.queue_enter_time)"></td>
                </tr>
                <tr>
                  <td><b>Позиция в очереди</b></td>
                  <td v-text="call.queue_position"></td>
                </tr>
                <tr>
                  <td><b>Ожидание, сек.</b></td>
                  <td v-text="call.wait"></td>
                </tr>
                <tr>
                  <td><b>Агент</b></td>
                  <td v-text="call.agent"></td>
                </tr>
                <tr>
                  <td><b>Время соединения с оператором</b></td>
                  <td v-text="call.queue_agent_time"></td>
                </tr>
                <tr>
                  <td><b>Продолжительность, сек.</b></td>
                  <td v-text="call.duration"></td>
                </tr>
                <tr>
                  <td><b>Удержание (Hold), сек</b></td>
                  <td v-text="call.hold"></td>
                </tr>
                <tr>
                  <td><b>Время завершения</b></td>
                  <td v-text="call.queue_end_time"></td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-simple-table
              v-if="call.meta !== undefined && call.meta !== null && callInfoType === 'meta'"
              dense
            >
              <template #default>
                <tbody>
                  <tr>
                    <td><b>Количество слов оператора</b></td>
                    <td>{{ call.meta['agent_words_count'] }}</td>
                  </tr>

                  <tr>
                    <td><b>Количество прерываний оператора</b></td>
                    <td>{{ call.meta['interrupt_count_agent'] }}</td>
                  </tr>

                  <tr>
                    <td><b>Количество прерываний клиента</b></td>
                    <td>{{ call.meta['interrupt_count_client'] }}</td>
                  </tr>

                  <tr>
                    <td><b>Длительность прерываний оператора, сек.</b></td>
                    <td>{{ convertMsToSec(call.meta['interrupt_duration_agent']) }}</td>
                  </tr>
                  <tr>
                    <td><b>Длительность прерываний клиента, сек.</b></td>
                    <td>{{ convertMsToSec(call.meta['interrupt_duration_client']) }}</td>
                  </tr>

                  <tr>
                    <td><b>Максимальная продолжительность тишины, сек.</b></td>
                    <td>{{ convertMsToSec(call.meta['max_silence_duration']) }}</td>
                  </tr>
                  <tr>
                    <td><b>Максимальная продолжительность разговора оператора, сек.</b></td>
                    <td>{{ convertMsToSec(call.meta['max_speech_duration_agent']) }}</td>
                  </tr>

                  <tr>
                    <td><b>Длительность разговора оператора, сек.</b></td>
                    <td>{{ convertMsToSec(call.meta['speech_duration_agent']) }}</td>
                  </tr>
                  <tr>
                    <td><b>Длительность разговора клиента, сек.</b></td>
                    <td>{{ convertMsToSec(call.meta['speech_duration_client']) }}</td>
                  </tr>

                </tbody>
              </template>
            </v-simple-table>

            <v-simple-table dense v-if="callInfoType === 'browsing_history'">
              <template #default>
                <tbody>
                  <tr v-for="viewer in call.viewers" :key="`viewer_${viewer.date}`">
                    <td><b>{{ viewer.name }}</b></td>
                    <td>{{ formatDate(viewer.date) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-simple-table dense v-if="callInfoType === 'history'">
              <template #default>
                <tbody>
                  <tr v-for="(historyItem, index) in call.history" :key="`history_${index}`">
                    <td>{{ formatDate(historyItem.time) }}</td>
                    <td><b>{{ historyItem.event }}</b></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

        </v-card-text>
      </v-card>
    </div>

    <!-- Результат звонка -->
    <div v-if="forms.length || aiStatistic.length" class="col-md-6 col-lg-4">
      <v-card class="mt-4">
        <v-card-title>Результат звонка</v-card-title>

        <v-tabs v-model="resultTab" show-arrows>

          <v-tab
            v-for="form in forms"
            :key="`form_${form.uniqueId}`"
          >
            <v-icon class="mr-2">mdi-list-box-outline</v-icon>
            {{ form.formTitle }}
          </v-tab>

          <v-tab
            v-for="(aiAnalysis, key) in aiStatistic"
            :key="`ai_analysis_${key}`"
          >
            <v-icon class="mr-2">mdi-robot-excited-outline</v-icon>
            {{ aiAnalysis.title }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="resultTab">
          <!-- Формы -->
          <v-tab-item
            v-for="form in forms"
            :key="`form_tab_${form.uniqueId}`"
          >
            <v-card>
              <v-card-text class="pt-0">
                <v-simple-table dense>
                  <tbody>
                    <tr v-for="field in form.data" :key="`form_field_${form.uniqueId}-${field.code}`">
                      <td><b>{{ field.title }}</b></td>
                      <td>{{ field.value }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- ИИ анализ -->
          <v-tab-item
            v-for="(aiAnalysis, key) in aiStatistic"
            :key="`ai_analysis_${key}`"
          >
            <v-card>
              <v-card-text>
                <p
                  v-for="item in aiAnalysis.statisticPart1"
                  :key="`statisticTable_${item.code}`"
                >
                  <b>{{ item.label }}</b><br>
                  {{ item.value }}
                </p>

                <v-simple-table>
                  <template #default>
                    <tbody>
                      <tr
                        v-for="item in aiAnalysis.statisticPart2"
                        :key="`statisticTable_${item.code}`"
                      >
                        <td>
                          <b>{{ item.label }}</b>
                        </td>

                        <td v-if="item.code === 'final_grade'" class="text-center">
                          <v-chip dark>{{item.value}}</v-chip>
                        </td>

                        <td v-else class="text-center">{{item.value}}</td>
                      </tr>

                      <tr v-if="call.accord">
                        <td><b>Соответствие диалога скрипту</b></td>
                        <td><v-chip dark>{{call.accord}}%</v-chip></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>

              <v-card-text v-if="aiAnalysis.isCorrect === null" class="d-flex">
                <v-btn class="flex-grow-1" small color="success" @click="setIsCorrect(aiAnalysis, true)">Корректно</v-btn>
                <v-btn class="flex-grow-1 ml-2" small color="red" @click="setIsCorrect(aiAnalysis, false)">Не корректно</v-btn>
              </v-card-text>

              <v-card-text
                v-else-if="aiAnalysis.isCorrect === true"
                class="d-flex justify-space-between success--text"
              >
                <span>Корректно</span>
                <v-icon color="success">mdi-check-bold</v-icon>
              </v-card-text>

              <v-card-text
                v-else-if="aiAnalysis.isCorrect === false"
                class="d-flex justify-space-between red--text"
              >
                <span>Не корректно</span>
                <v-icon color="red">mdi-check-bold</v-icon>
              </v-card-text>

            </v-card>
          </v-tab-item>
        </v-tabs-items>

      </v-card>
    </div>

    <!-- Словари и Стенограмма -->
    <div class="col-md-6 col-lg-4">
      <v-card v-if="call['markers']" class="mt-4">
        <v-card-text class="pt-0 ">
          <div v-if="call['markers'] && call['markers'].length > 0" class="subheading black--text">
            <v-badge
              v-for="(marker, index) in call['markers']" :key="index"
              class="mr-2 my-3"
              bordered
              color="success"
              overlap
            >
              <template v-slot:badge>
                x{{ marker['words_count'] }}
              </template>
              <v-chip
                @click="goToPhrase(marker)"
                class=""
                color="success"
                label
                outlined
                title="Количество звонков с КЛН"
              >
                {{ marker['dictionary_name'] }}
              </v-chip>
            </v-badge>

            <v-alert
              v-if="call['markers'].length === 0"
              dense
              outlined
              type="warning"
            >
              Словарей нет
            </v-alert>
          </div>
          <div v-else class="subheading black--text">
            <v-alert
              dense
              outlined
              type="warning"
            >
              Словарей нет
            </v-alert>
          </div>

        </v-card-text>
      </v-card>

      <!-- Стенограмма -->
      <v-card class="mt-4" v-if="allowTranscribe">
        <v-card-title>
          Стенограмма
          <v-btn
            v-if="call.transcribe"
            class="ml-2"
            small
            icon
            @click="copyTranscript"
          >
            <v-icon color="info">mdi-content-copy</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <Transcribe :messages="call.transcribe" />
        </v-card-text>
      </v-card>
    </div>

    <!-- Отзыв -->
    <div v-if="'comments' in call"
      class="col-md-6 col-lg-4"
    >
      <v-card class="mt-4">

        <v-card-title>Отзыв</v-card-title>

        <v-tabs v-model="formTab" show-arrows>
          <v-tab
            v-if="complaints.length"
            href="#complaints"
          >Отзывы <v-chip  small class="ml-2">{{ complaints.length }}</v-chip></v-tab>

          <v-tab
            v-if="call.project_id && call.questionnaire_id"
            href="#newComplaint"
          >Создать отзыв</v-tab>

          <v-tab
            v-if="'comments' in call"
            href="#comments"
          >Комментарии</v-tab>
        </v-tabs>


        <v-tabs-items v-model="formTab">
          <v-tab-item value="complaints">
            <v-card>
              <v-card-text>

                <v-expansion-panels hover accordion mandatory>
                  <v-expansion-panel
                    v-for="(item,i) in complaints"
                    :key="i"
                  >
                    <v-expansion-panel-header>
                      <v-row>
                        <v-col cols="7">{{ formatDate(item.created_at) }}</v-col>
                        <v-col v-if="item.created_by">{{ item.created_by }}</v-col>
                      </v-row>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-simple-table dense>
                        <template #default>

                          <tbody>
                            <tr>
                              <td><b>№:</b></td>
                              <td>{{ item.id }}</td>
                            </tr>

                            <tr v-if="item.project">
                              <td><b>Заказчик:</b></td>
                              <td>{{ item.project }}</td>
                            </tr>

                            <tr v-if="item.type">
                              <td><b>Тип отзыва:</b></td>
                              <td>{{ item.type }}</td>
                            </tr>

                            <tr v-if="item.kln !== null">
                              <td><b>КЛН:</b></td>
                              <td>
                                <v-row>
                                  <v-col class="col">
                                    <v-chip small color="green" text-color="white">{{ item.kln }}</v-chip>
                                  </v-col>
                                </v-row>
                              </td>
                            </tr>

                            <tr v-if="item.criterias.length">
                              <td><b>Критерии:</b></td>
                              <td>
                                <v-row class="row" v-for="(criteria, index) in item.criterias" :key="`criteria_${index}`">
                                  <v-col cols="8">
                                    <v-tooltip v-if="criteria.description" bottom>
                                      <template #activator="{ on }">
                                        <span v-on="on">{{ criteria.title }}</span>
                                      </template>
                                      <span>{{ criteria.description }}</span>
                                    </v-tooltip>
                                    <span v-else>{{ criteria.title }}</span>
                                  </v-col>
                                  <v-spacer />
                                  <v-col>{{ criteria.weight }}</v-col>
                                </v-row>
                              </td>
                            </tr>

                            <tr v-if="item.comment">
                              <td><b>Коммент:</b></td>
                              <td>
                                <v-row>
                                  <v-col>
                                    <v-sheet
                                      v-if="item.comment"
                                      color="green"
                                      dark
                                      rounded
                                      class="pa-2"
                                      style="height: 100%;"
                                    >
                                      {{ item.comment }}
                                    </v-sheet>
                                  </v-col>
                                </v-row>
                              </td>
                            </tr>

                            <tr v-if="item.created_by">
                              <td><b>Автор:</b></td>
                              <td>{{ item.created_by }}</td>
                            </tr>

                            <tr v-if="item.created_at">
                              <td><b>Дата:</b></td>
                              <td>{{ utils.formattingStringWithTime(item.created_at, true /*with sec*/) }}</td>
                            </tr>

                            <tr>
                              <td>
                                <v-tooltip bottom>
                                  <template #activator="{ on }">
                                    <v-icon v-on="on">mdi-account-check</v-icon>
                                    <span>:</span>
                                  </template>
                                  <span>Отзыв отработан</span>
                                </v-tooltip>
                              </td>

                              <td>

                                <v-tooltip v-if="item.mining_date" bottom>
                                  <template #activator="{ on }">
                                    <div v-on="on">
                                      <v-icon color="green">mdi-checkbox-marked</v-icon>
                                    </div>
                                  </template>
                                  <span>Отработан {{ item.mining_date }}</span>
                                </v-tooltip>

                                <v-tooltip v-else bottom>
                                  <template #activator="{ on }">
                                    <div v-on="on">
                                      <v-btn
                                        color="green"
                                        icon
                                        :disabled="item.mining_date_write === false"
                                        @click="preShowMiningDialog(item.id, item.source)"
                                      >
                                        <v-icon>mdi-checkbox-blank-outline</v-icon>
                                      </v-btn>
                                    </div>
                                  </template>
                                  <span>Не отработан</span>
                                </v-tooltip>

                              </td>

                            </tr>

                            <tr v-if="item.is_confirmed">
                              <td><b>Корректно/Не корректно:</b></td>
                              <td v-if="item.is_valid"><v-icon color="success">mdi-check</v-icon></td>
                              <td v-else><v-icon color="red">mdi-close</v-icon></td>
                            </tr>

                            <tr v-if="item.current_status">
                              <td><b>Калибровка оператором:</b></td>
                              <td>{{ item.current_status }}</td>
                            </tr>

                            <tr v-if="item.calibration_comment">
                              <td><b>Комментарий калибровки:</b></td>
                              <td>{{ item.calibration_comment }}</td>
                            </tr>

                          </tbody>
                        </template>
                      </v-simple-table>

                      <v-card v-if="item.operator_comment" outlined class="mt-3 pa-3">
                        <div class="d-flex align-center justify-space-between">
                          <div class="d-flex align-center">
                            <v-icon color="blue darken-1" class="mr-2">mdi-comment-account-outline</v-icon>
                            <v-chip v-if="item.current_status" small label class="mr-2">{{ item.current_status }}</v-chip>
                          </div>

                          <div v-if="item.need_clouse_dispute">

                            <v-tooltip bottom>
                              <template #activator="{ on }">
                                <v-btn icon small color="success" v-on="on" @click="agreeWithOperator(item)">
                                  <v-icon>mdi-thumb-up-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Согласен</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                              <template #activator="{ on }">
                                <v-btn icon small color="red" v-on="on" @click="disagreeWithOperator(item)">
                                  <v-icon>mdi-thumb-down-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Не согласен</span>
                            </v-tooltip>
                          </div>
                        </div>

                        <div class="mt-2" >
                          <span class="caption font-weight-bold text--secondary">Комментарий оператора: </span>
                          <span class="body-2">{{ item.operator_comment }}</span>
                        </div>
                      </v-card>

                      <div v-if="item.is_auto && !item.is_confirmed" class="d-flex mt-2">
                        <v-btn
                          class="flex-grow-1"
                          small
                          color="success"
                          @click="setIsCorrectAi(item, true)"
                        >Корректно</v-btn>
                        <v-menu
                          :value="!!incorrectAiMenuOpen[item.id]"
                          :close-on-content-click="false"
                          offset-y
                          top
                          @input="val => $set(incorrectAiMenuOpen, item.id, val)"
                        >
                          <template #activator="{ on, attrs }">
                            <v-btn
                              class="flex-grow-1 ml-2"
                              small
                              color="red"
                              v-bind="attrs"
                              v-on="on"
                              @click="openIncorrectAiMenu(item)"
                            >Не корректно</v-btn>
                          </template>
                          <v-card class="pa-3" min-width="280">
                            <v-text-field
                              v-model="incorrectAiCalibrationComment[item.id]"
                              dense
                              hide-details
                              filled
                              label="Комментарий калибровки"
                            />
                            <div class="d-flex justify-end mt-3">
                              <v-btn
                                text
                                small
                                @click="cancelIncorrectAi(item)"
                              >Отменить</v-btn>
                              <v-btn
                                color="primary"
                                small
                                class="ml-2"
                                @click="confirmIncorrectAi(item)"
                              >Подтвердить</v-btn>
                            </div>
                          </v-card>
                        </v-menu>
                      </div>

                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="newComplaint">
            <v-card dense>
              <v-card-text>
                <v-col cols="12" xs="12">
                  <v-text-field
                    v-model="call.project"
                    hide-details
                    dense
                    disabled
                    label="Заказчик"
                    single-line
                  />
                </v-col>

                <v-col cols="12" xs="12">
                  <v-text-field
                    v-model="call.agent"
                    disabled
                    dense
                    hide-details
                    label="Оператор"
                    single-line
                  />
                </v-col>

                <v-col cols="12" xs="12">
                  <v-select
                    v-model="newComplaint.type_id"
                    label="Тип отзыва"
                    :items="questionnaireTypes"
                    item-text="label"
                    item-value="id"
                    dense
                    hide-details
                    no-data-text="Ничего не найдено"
                  />
                </v-col>

                <v-expansion-panels v-if="criteriaList.length" class="mb-2">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Критерии
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-row>
                        <v-col
                          v-for="criteria in criteriaList"
                          :key="criteria.id"
                          cols="12"
                          xs="12"
                          class="py-0 my-0"
                        >
                          <v-checkbox
                            v-model="newComplaint.criteria_ids"
                            :label="criteria.title"
                            :value="criteria.id"
                            class="py-0 my-0"
                            style="transform: scale(0.95);"
                            dense
                          />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-col cols="12" xs="12" class="pa-0 pl-3">
                  <v-checkbox
                    v-model="newComplaint.notify_operator"
                    label="Уведомлять оператора"
                    class="py-0 my-0"
                    dense
                  />
                </v-col>

                <v-col cols="12" xs="12" class="pa-0 pl-3">
                  <v-checkbox
                    v-model="newComplaint.skip_calculation"
                    label="Не расчитывать клн"
                    class="py-0 my-0"
                    dense
                  />
                </v-col>

                <v-col cols="12" xs="12">
                  <v-textarea
                    v-model="newComplaint.comment"
                    label="Комментарий"
                    dense
                    hide-details
                    auto-grow
                    rows="1"
                  />
                </v-col>

                <v-btn color="success" class="mt-5" @click="saveComplaint">Сохранить</v-btn>

              </v-card-text>
            </v-card>

          </v-tab-item>

          <v-tab-item value="comments">
            <v-card>
              <v-card-text>
                <v-text-field v-model="newComment.comment" label="Комментарий" />

                <v-divider />

                <div class="d-flex flex-wrap" style="column-gap: 50px;">
                  <v-checkbox v-model="newComment.is_ignore" label="Игнор" dense hide-details class="mt-0" />
                  <v-checkbox v-model="newComment.is_hold" label="Удержание" dense hide-details class="mt-0" />
                  <v-checkbox v-model="newComment.is_drop" label="Сброс" dense hide-details class="mt-0" />
                </div>

                <v-btn color="success" class="mt-3" @click="saveCallComment">
                  Сохранить <v-icon>mdi-content-save</v-icon>
                </v-btn>

                <v-list two-line>
                  <v-list-item v-for="(comment, index) in comments" :key="index">
                    <v-list-item-content>
                      <v-list-item-title v-text="comment.fullname" />
                      <v-list-item-subtitle
                        class="text--primary"
                        v-text="formatDate(comment.created_at)"
                      />
                      <v-list-item-subtitle v-text="comment.comment" />
                      <v-list-item-subtitle><v-chip small v-if="comment.is_ignore">Игнор</v-chip></v-list-item-subtitle>
                      <v-list-item-subtitle><v-chip small v-if="comment.is_hold">Удержание</v-chip></v-list-item-subtitle>
                      <v-list-item-subtitle><v-chip small v-if="comment.is_drop">Сброс</v-chip></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn v-if="comment.is_owner" icon @click="deleteComment(comment.id)">
                        <v-icon color="grey lighten-1">mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

              </v-card-text>
            </v-card>
          </v-tab-item>

        </v-tabs-items>

      </v-card>
    </div>

   <!-- Анкета -->
    <div v-if="contactForm && contactForm.length" class="col-md-6 col-lg-4">
      <v-card class="mt-4">
        <v-card-title>Анкета</v-card-title>
        <v-card-text>
          <v-form ref="questionnaireForm">
            <v-container fluid>
              <v-row v-for="field in contactForm" :key="field.id">
                <v-col cols="12">
                  <!-- Селект -->
                  <v-select
                    v-if="field.type === 'select'"
                    v-model="field.selectedOptionId"
                    :items="field.options"
                    item-text="title"
                    item-value="id"
                    :label="field.label || `Поле ${field.id}`"
                    @change="(newId) => updateSelectField(field, newId)"
                  />
                  <v-text-field
                    v-else
                    v-model="field.value"
                    :label="field.label || `Поле ${field.id}`"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>

          <div class="d-flex justify-end mt-3">
            <v-btn color="primary" class="mr-2" @click="saveQuestionnaire">Сохранить</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!-- Модалка отработки -->
    <v-dialog
      v-model="showMiningDialog"
      width="500"
    >
      <v-card>
        <v-card-title>Отработать звонок?</v-card-title>

        <v-card-text>Будет записано время отработки</v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            @click="showMiningDialog = false"
          >Отмена</v-btn>
          <v-btn
            color="green"
            @click="setMining"
          >Да</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AudioPlayer v-if="showPlayer" />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Transcribe from '~/components/partials/Call/Transcribe'
import AudioPlayer from '~/components/partials/AudioPlayer'
import moment from 'moment'
import { axios } from "~/plugins/axios"

export default {
  name: 'CallInfo',
  components: {
    Transcribe,
    AudioPlayer,
  },

  props: {
    uid: String,
  },

  data() {
    return {
      showPlayer: false,
      callInfoType: 'default',
      newComplaint: {
        questionnaire_id: null,
        comment: '',
        criteria_ids: [],
        notify_operator: true,
        skip_calculation: false,
        type_id: null,
      },
      statisticPart1: [],
      statisticPart2: [],
      statisticFail: '',

      aiStatistic: [],

      isStatisticLoaded: false,
      isStatisticLoading: false,
      newComment: {
        comment: '',
        is_ignore: false,
        is_hold: false,
        is_drop: false,
      },
      allForms: [],
      forms: [],
      formTab: 'complaints',
      showMiningDialog: false,
      resultTab: null,
      complaints: [],
      currentComplaintId: null,
      currentComplaintSource: null,

      questionnairesList: [],
      criteriaList: [],
      questionnaireTypes: [],

      incorrectAiMenuOpen: {},
      incorrectAiCalibrationComment: {},
    }
  },

  computed: {
    ...mapGetters({
      call: 'reports_speech_analysis/call',
      comments: 'reports_speech_analysis/callComments',
      currentUser: 'user/currentUser',
      hasPermission: 'user/hasPermission',
      hasRole2: 'user/hasRole2',
      selectedDictionary: 'transcribe/selectedDictionary',
      statistic: 'reports_speech_analysis/statistic',
      contactForm: 'reports_speech_analysis/contactForm',
    }),

    allowTranscribe() {
      return this.hasPermission('statiz.call-transcribe')
    },

    callStatus() {
      switch (this.call.status) {
        case 'success': return 'primary'
        case 'warning': return 'warning'
        case 'danger': return 'error'
        case 'info': return 'info'
        default: return 'default'
      }
    },

    callUrl() {
      return `${process.env.VUE_APP_API_DOMAIN}${this.$router.resolve({
        name: 'SpeechAnalysisCall',
        params: {
          uid: this.uid,
        }
      }).href}`
    },
  },

  watch: {
    uid(newVal) {
      this.uidChanging(newVal)
    },

    call(newVal) {
      if (newVal !== null) {
        if (this.call['audios'] === undefined || this.call['audios'].length === 0) return

        this.initPlaylist(this.call['audios'])
        this.showPlayer = true
      }
    },
  },

  methods: {
    ...mapActions({
      addCallComment: 'reports_speech_analysis/addCallComment',
      changeSelectedDictionary: 'transcribe/changeSelectedDictionary',
      changeSelectedPhrase: 'transcribe/changeSelectedPhrase',
      clearCall: 'reports_speech_analysis/clearCall',
      deleteComment: 'reports_speech_analysis/deleteCallComment',
      initPlaylist: 'audioPlayer/initPlaylist',
      loadCall: 'reports_speech_analysis/loadCall',
      loadGraph: 'graphql/loadGraph',
      loadStatistic: 'reports_speech_analysis/loadStatistic',
      setError: 'shared/setError',
      setSuccess: 'shared/setSuccess',
      setMiningDate: 'complaints_report/setMiningDate',
      loadComplaints: 'reports_speech_analysis/loadComplaints',
      loadQuestionnairesList: 'reports_speech_analysis/loadQuestionnairesList',
      loadCriteriaList: 'reports_speech_analysis/loadCriteriaList',
      loadQuestionnaireTypes: 'reports_speech_analysis/loadQuestionnaireTypes',
      createcomplaints: 'reports_speech_analysis/createcomplaints',
      updateComplaint: 'reports_speech_analysis/updateComplaint',
      confirmAiRate: 'reports_speech_analysis/confirmAiRate',
      agreedWithOperatorComment: 'reports_speech_analysis/agreedWithOperatorComment',
      disagreedWithOperatorComment: 'reports_speech_analysis/disagreedWithOperatorComment',
      fetchContactForm: 'reports_speech_analysis/fetchContactForm',
      updateContactField: 'reports_speech_analysis/updateContactField',
    }),

    async uidChanging(uid) {
      if (uid == null) return
      await this.loadCall({uid, query: {
        with: 'transcribe,audios,markers,meta,complaints,viewers,history,comments,holds,analyses,accord,transfers'
      }})

      if (this.call && 'analyses' in this.call) this.fillAiStatistic(this.call.analyses)

      this.questionnairesList = await this.loadQuestionnairesList()
      this.questionnaireTypes = await this.loadQuestionnaireTypes()
      await this.fetchContactForm(uid);

      if (this.call.questionnaire_id) {
        this.newComplaint.questionnaire_id = this.call.questionnaire_id
        this.loadCriterias(this.call.questionnaire_id)
      } else {
        this.newComplaint.questionnaire_id = null
      }

      this.fillComplaints()
      this.clearNewComplaint()
      this.criteriaList.length = 0
    },

    goToPhrase(dictionary) {
      this.changeSelectedDictionary(dictionary)
      this.changeSelectedPhrase()
    },

    async copyUrl() {
      let urlInput = await document.querySelector('.urlInput')
      urlInput.select()
      document.execCommand('copy')

      alert('Ссылка на звонок скопирована в буфер обмена')
    },

    formatDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },

    convertMsToSec(ms) {
      return Math.floor(ms / 1000)
    },

    saveCallComment() {
      const payload = {
        uid: this.call.uid,
        ...this.newComment,
      }

      this.addCallComment(payload).then(() => {
        this.newComment.comment = ''
        this.newComment.is_ignore = false
        this.newComment.is_hold = false
        this.newComment.is_drop = false
      })
    },

    fillAiStatistic(statistic) {
      this.aiStatistic = []

      for (let i = 0; i < statistic.length; i++) {
        const analisis = statistic[i]

        this.aiStatistic[i] = {
          id: analisis.id,
          isCorrect: analisis.is_correct,
          title: analisis.title,
          statisticPart1: [],
          statisticPart2: [],
        }

        let conversation_tags = analisis.data.find(s => s.code === 'conversation_tags')
        if (conversation_tags) conversation_tags.value = conversation_tags.value.join(', ').trim()

        analisis.data.forEach(item => {
          if (
            typeof item.value === 'string'
            && ['да', 'нет'].includes(item.value.toLowerCase())
          ) this.aiStatistic[i].statisticPart2.push(item)
          else if (typeof item.value === 'string') this.aiStatistic[i].statisticPart1.push(item)
          else this.aiStatistic[i].statisticPart2.push(item)
        })
      }

      this.isStatisticLoaded = true
    },

    async fillComplaints() {
      const resultComplaints = []

      const newComplaintsRaw = await this.loadComplaints({uid: this.uid})
      const oldComplaints = this.call?.complaints


      for (const complaint of newComplaintsRaw) {
        const item = {
          id: complaint.id,
          project: complaint.project,
          type: complaint.type?.label,
          kln: complaint.kln,
          criterias: complaint.criterias || [],
          comment: complaint.comment,
          created_at: complaint.created_at,
          mining_date: complaint.mining_date,
          mining_date_write: complaint.mining_date_write,
          source: 'gate',
          is_valid: complaint.is_valid,
          is_auto: complaint.is_auto,
          is_confirmed: complaint.is_confirmed,
          current_status: complaint.current_status,
          operator_comment: complaint.operator_comment,
          need_clouse_dispute: complaint.need_clouse_dispute,
          calibration_comment: complaint.calibration_comment,
        }
        let created_by = ''

        if (complaint.creator) {
          if (complaint?.creator?.last_name) created_by = complaint.creator.last_name
          if (complaint?.creator?.first_name) created_by += ' ' + complaint.creator.first_name
        }

        item.created_by = created_by.trim()

        resultComplaints.push(item)
      }
      for (const complaint of oldComplaints) {
        const item = {
          id: complaint.id,
          created_by: complaint.created_by,
          project: complaint.project,
          type: complaint.type,
          kln: complaint.kln,
          comment: complaint.comment,
          created_at: complaint.created_at,
          mining_date: complaint.mining_date,
          mining_date_write: complaint.mining_date_write,
          criterias: [],
          source: 'statix',
        }

        const criteriaArr = this.getCriteriaArray(complaint.criterias_transcript)

        for (const criteria of criteriaArr) {
          const title = criteria.replace(/ -\d+ КЛН/g, '')
          const weight = criteria.match(/\d+/g)[0]
          item.criterias.push({
            title,
            weight,
            description: null
          })
        }

        resultComplaints.push(item)
      }

      this.complaints = resultComplaints
      if (this.complaints.length) this.formTab = 'complaints'
      else this.formTab = 'newComplaint'
    },

    copyTranscript() {
      let str = ''
      this.call.transcribe.forEach(phrase => {
        let message = phrase.is_client ? '[абонент] ' : '[оператор] '

        message += phrase.text.trim()
        message += '\n'

        str += message
      })

      window.navigator.clipboard.writeText(str).then(() => {
        this.setSuccess({message: 'Скопировано в буфер'})
      }, (err) => {
        this.setError({message: err})
      })
    },

    async loadAllForms() {
      let q = `forms {
        data {
          id
          title
        }
      }`

      let res = await this.loadGraph(q)
      this.allForms = res.forms.data.map(form => ({
        id: form.id,
        name: form.title
      }))
    },

    async loadForms() {
      let q = `Call(uid: "${this.uid}") {
        call_cards {
          id
          data
          form {
            title
          }
        }
        filled_forms {
          id
          data
          form {
            title
          }
        }
      }`

      let res = await this.loadGraph(q)
      let forms = res.Call?.call_cards?.map(el => ({
        id: el.id,
        uniqueId: this.utils.randomString(),
        data:JSON.parse(el.data),
        formTitle: el.form.title,
      }))

      res.Call?.filled_forms?.forEach(el => {
        let newItem = {
          id: el.id, // id filledForm и callCard могут совпадать, пока id не используется, просто напоминание =)
          uniqueId: this.utils.randomString(),
          data:JSON.parse(el.data),
          formTitle: el.form.title,
        }

        forms.push(newItem)
      })

      this.forms = forms
    },

    getCriteriaArray(criteriaString) {
      if (!criteriaString) return []
      let items = criteriaString.split('|')

      let clearItems = items.filter(el => (el != null && el !== ''))
      return clearItems.map(el => el.trim())
    },

    async setMining() {
      const payload = {
        source: this.currentComplaintSource,
        complaintId: this.currentComplaintId,
      }
      await this.setMiningDate(payload)
      this.showMiningDialog = false
      await this.uidChanging(this.uid)
    },

    async setIsCorrect(aiAnalisis, val) {
      const url = `/api/analysis-ai/${aiAnalisis.id}/set-is-correct`

      try {
        await axios.post(url, {is_correct: val})
        aiAnalisis.isCorrect = val
        this.$forceUpdate()
      } catch (error) {
        let payload = {message: error}
        if (error.response.data) payload = error.response.data
        this.setError(payload)
      }
    },

    preShowMiningDialog(complaintId, source) {
      this.currentComplaintId = complaintId
      this.currentComplaintSource = source
      this.showMiningDialog = true
    },

    async loadCriterias(questionnaireId) {
      this.criteriaList = await this.loadCriteriaList(questionnaireId)
      this.newComplaint.criteria_ids.length = 0
    },

    async saveComplaint() {
      const payload = {
        ...this.newComplaint,
        uid: this.uid,
      }

      await this.createcomplaints(payload)
        .then(() => {
          this.uidChanging(this.uid)
        })
    },

    clearNewComplaint() {
      this.newComplaint.comment = ''
      this.newComplaint.criteria_ids = []
      this.newComplaint.notify_operator = true
      this.newComplaint.skip_calculation = false
      this.newComplaint.type_id = null
    },

    openIncorrectAiMenu(item) {
      this.$set(this.incorrectAiCalibrationComment, item.id, item.calibration_comment || '')
    },

    cancelIncorrectAi(item) {
      this.$set(this.incorrectAiMenuOpen, item.id, false)
    },

    confirmIncorrectAi(item) {
      const comment = this.incorrectAiCalibrationComment[item.id] ?? ''
      this.setIsCorrectAi(item, false, comment)
        .then(() => {
          this.$set(this.incorrectAiMenuOpen, item.id, false)
        })
    },

    setIsCorrectAi(complaint, isValid, calibrationComment) {
      const payload = {
        complaintId: complaint.id,
        is_valid: isValid,
      }

      if (calibrationComment !== undefined) {
        payload.calibration_comment = calibrationComment
      }

      return this.confirmAiRate(payload)
        .then(() => {
          complaint.is_confirmed = true
          complaint.is_valid = isValid
          if (calibrationComment !== undefined) {
            complaint.calibration_comment = calibrationComment
          }
        })
    },

    agreeWithOperator(item) {
      this.agreedWithOperatorComment(item.id)
        .then((data) => {
          item.need_clouse_dispute = false
          item.current_status = data.status
        })
    },

    disagreeWithOperator(item) {
      this.disagreedWithOperatorComment(item.id)
        .then((data) => {
          item.need_clouse_dispute = false
          item.current_status = data.status
        })
    },

    getFieldLabel(field) {
      return field.label || `Поле ${field.id}`;
    },

    getSelectedOptionTitle(field) {
      if (field.type === 'select' && field.options) {
        const selected = field.options.find(opt => opt.id === field.selectedOptionId);
        return selected ? selected.title : '';
      }
      return field.value || '';
    },

    updateSelectField(field, newId) {
      const selectedOption = field.options.find(opt => opt.id === newId);
      if (selectedOption) {
        field.selectedOptionId = newId;
        field.value = selectedOption.title; // обновляем текстовое значение
      }
    },

    async saveQuestionnaire() {
      try {
        const promises = this.contactForm.map(field => {
          const data = field.type === 'select'
            ? { value: field.value, select_option_id: field.selectedOptionId }
            : { value: field.value };
          return this.updateContactField({ id: field.id, data });
        });
        await Promise.all(promises);
        this.contactForm.forEach(field => {
          if (field.type === 'select') {
            field.originalSelectedOptionId = field.selectedOptionId;
            field.originalValue = field.value;
          } else {
            field.originalValue = field.value;
          }
        });
        this.$store.commit('shared/SET_SUCCESS', { message: 'Анкета сохранена' }, { root: true });
      } catch (error) {
        console.error(error);
        this.$store.commit('shared/SET_ERROR', { message: 'Ошибка сохранения анкеты' }, { root: true });
      }
    },

    test(item) {
      console.log(item)
    },
  },

  async mounted() {
    await this.uidChanging(this.uid)
    this.loadForms()
  },

  beforeDestroy() {
    this.clearCall()
  },
}
</script>

<style scoped>
.custom_capitalize:first-letter {
  text-transform: capitalize;
}

.urlInput {
  position: absolute;
  z-index: -1;
}

.copyUrl-chip {
  cursor: pointer;
}
</style>